import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

export const userManager = new UserManager({
  authority: process.env.REACT_APP_IDENTITY_CENTER_API_URL,
  client_id: process.env.REACT_APP_IDENTITY_CENTER_CLIENT_ID,
  scope: process.env.REACT_APP_IDENTITY_CENTER_SCOPE,
  redirect_uri:
    process.env.REACT_APP_IDENTITY_CENTER_REDIRECT_URI ||
    window.location.origin + '/callback',
  post_logout_redirect_uri:
    process.env.REACT_APP_IDENTITY_CENTER_POST_LOGOUT_REDIRECT_URI ||
    window.location.origin,
  silent_redirect_uri:
    process.env.REACT_APP_IDENTITY_CENTER_SILENT_REDIRECT_URI ||
    window.location.origin + '/silent-renew',
  response_type: 'code',
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTimeInSeconds: 60,
  includeIdTokenInSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});

export function getUserManager() {
  return userManager;
}
